export const HOME_CATEGORY_GROUPS = [
  { key: 'antipasti', label: 'Antipasti', cta: 'Scopri tutti gli antipasti' },
  { key: 'primi', label: 'Primi', cta: 'Scopri tutti i primi' },
  { key: 'secondi', label: 'Secondi', cta: 'Scopri tutti i secondi' },
  { key: 'contorni', label: 'Contorni', cta: 'Scopri tutti i contorni' },
];

const normalizeCategoryValue = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');

const CATEGORY_MATCHERS = {
  antipasti: [
    'antipasto',
    'antipasti',
    'fritto',
    'fritti',
    'bruschetta',
    'bruschette',
    'stuzzicheria',
    'stuzzicherie',
    'sfizio',
    'sfizi',
  ],
  primi: [
    'primo',
    'primi',
    'primo piatto',
    'primi piatti',
    'pasta',
    'risotto',
    'risotti',
    'gnocco',
    'gnocchi',
    'lasagna',
    'lasagne',
    'zuppa',
    'zuppe',
  ],
  secondi: [
    'secondo',
    'secondi',
    'secondo piatto',
    'secondi piatti',
    'carne',
    'pesce',
    'pollo',
    'arrosto',
    'griglia',
  ],
  contorni: [
    'contorno',
    'contorni',
    'verdura',
    'verdure',
    'insalata',
    'insalate',
    'ortaggi',
  ],
};

const getCategoryCandidateValues = (category) => {
  if (typeof category === 'string') {
    return [normalizeCategoryValue(category)].filter(Boolean);
  }

  return [
    normalizeCategoryValue(category?.slug),
    normalizeCategoryValue(category?.name),
    normalizeCategoryValue(category?.category_name),
    normalizeCategoryValue(category?.label),
    normalizeCategoryValue(category?.title),
  ].filter(Boolean);
};

export const detectCategoryGroupKey = (category) => {
  const values = getCategoryCandidateValues(category);

  for (const value of values) {
    for (const [groupKey, aliases] of Object.entries(CATEGORY_MATCHERS)) {
      if (aliases.some((alias) => value === alias || value.includes(alias))) {
        return groupKey;
      }
    }
  }

  return null;
};

export const buildCategoryGroups = (categories, allowedKeys = HOME_CATEGORY_GROUPS.map((group) => group.key)) => {
  const definitions = HOME_CATEGORY_GROUPS.filter((group) => allowedKeys.includes(group.key));

  return definitions.map((definition) => {
    const matchedCategories = (Array.isArray(categories) ? categories : []).filter(
      (category) => detectCategoryGroupKey(category) === definition.key
    );

    const items = matchedCategories.flatMap((category) =>
      (Array.isArray(category.items) ? category.items : []).map((item) => ({
        ...item,
        sourceCategoryName: category.name || definition.label,
      }))
    );

    return {
      ...definition,
      categories: matchedCategories,
      items,
    };
  });
};
